// @flow

import {type RecordFactory, type RecordOf, Record} from 'immutable';

import {mergeNormalizedFetchData} from 'app/utils/redux';
import {type CommentType} from 'app/comments/types';

import {type CommentsActions, RECEIVE_COMMENTS} from './actions';

type CommentsContentTypeStructureType = {
  [string]: {
    allIds: Array<string>,
    byId: {[string]: CommentType},
  },
};

type StateShape = {
  procedure: CommentsContentTypeStructureType,
  taskinstance: CommentsContentTypeStructureType,
  policy: CommentsContentTypeStructureType,
  proceduregroup: CommentsContentTypeStructureType,
};

const StateFactory: RecordFactory<StateShape> = Record({
  procedure: {},
  taskinstance: {},
  policy: {},
  proceduregroup: {},
});

const comments = (
  state: RecordOf<StateShape> = StateFactory(),
  action: CommentsActions
): RecordOf<StateShape> => {
  switch (action.type) {
    case RECEIVE_COMMENTS: {
      const path = [action.contentType, action.id.toString()];

      // $FlowFixMe mismatch between redux method return vars and how they are used
      return state.setIn(
        path,
        // $FlowFixMe - our state shape has no getIn methods
        mergeNormalizedFetchData(action.data, state.getIn(path))
      );
    }

    default:
      return state;
  }
};

export default comments;
